<script lang="ts">
	import type { RequiredProduct } from '$lib/types';
	import { createSkuItemFromProduct, createSpecialSaleStore } from '$lib/store/specialSale.store';
	import { createProductFetcherStore } from '$lib/store/productFetcher.store';
	import ProductBundleRecommendationDisplay from '$lib/components/Product/SpecialSale/ProductBundleRecommendationDisplay.svelte';

	export let product: RequiredProduct;

	$: specialSaleStore = createSpecialSaleStore(createSkuItemFromProduct(product));
	$: chosenSale = $specialSaleStore.length > 0 ? $specialSaleStore[0] : null;
	$: saleProduct = (chosenSale?.handles?.length ?? 0) > 0 ? chosenSale!.handles[0] : null;
	$: productFetcher = saleProduct ? createProductFetcherStore(saleProduct) : null;
	$: resultingProduct = productFetcher ? $productFetcher![0] : null;
</script>

{#if resultingProduct?.data?.product?.product && chosenSale}
	<ProductBundleRecommendationDisplay
		sale={chosenSale}
		productData={resultingProduct.data.product}
	/>
{/if}
